export class AgentLlmConfig {
	model = "deepseek-v4-pro";
	contextWindowTokens = 360_000;
	anthropicMaxOutputTokens = 128_000;
}

export const agentLlmConfig = new AgentLlmConfig();
